// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Payment from './pages/Payment';
import Services from './pages/Services';
import Booking from './pages/Booking';
import Invoice from './pages/Invoice';
import Receipt from './pages/Receipt';
import ReceiptPackageMatching from './pages/ReceiptPackageMatching'; // เพิ่มการ import ReceiptPackageMatching
import Member from './pages/Member';
import Logout from './pages/Logout';
import Queues from './pages/Queues';
import Typeservices from './pages/Typeservices';
import ChangePassword from './pages/ChangePassword.js'; // นำเข้า ChangePassword
import Reports from './pages/Reports'; // Import the Reports page
import Reviews from './pages/Reviews';
import MemberMLM from './pages/MemberMLM';
import ContentTravel from './components/Content/ContentTravel'; // Import ContentTravel
import ExploreInternet from './pages/ExploreInternet';
import InternetView from './components/Content/InternetView';
import InternetHeaderView from './components/Content/InternetHeaderView';
//import IdeasLabView from './components/Content/IdeasLabView';
import ExploreIdeasLab from './pages/ExploreIdeasLab';
import ExploreBlog from './pages/ExploreBlog';
import ExploreTour from './pages/ExploreTour';
import ExploreBlogTTT from './pages/ExploreBlogTTT';
import PackageMatching from './pages/PackageMatching';

import TourPackage from './pages/TourPackage';

// Import Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

// const ReceiptPackageMatchingWrapper = () => {
//   const { userId } = useParams();
//   // userId จาก params จะเป็น string, แต่ ReceiptPackageMatching อาจจะคาดหวัง number
//   // ดังนั้นควรแปลงเป็น number ก่อนส่งไป
//   // แต่จากโค้ด ReceiptPackageMatching.js ที่คุณให้มา มันรับ userId เป็น string ได้
//   // และ API_URLS.SPECIFIC_USER(userId) ก็รับ string ได้
//   // ดังนั้นการ parseInt อาจจะไม่จำเป็น แต่ถ้า component ปลายทางต้องการ number ก็ควรทำ
//   return <ReceiptPackageMatching />; // Component ReceiptPackageMatching จะใช้ useParams() เอง
// };

const App = () => {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Receipt" element={<Receipt />} />        
        <Route path="/Invoice" element={<Invoice />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/Payment" element={<Payment />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Booking" element={<Booking />} />
        <Route path="/queues" element={<Queues />} />
        <Route path="/Member" element={<Member />} />
        <Route path="/change-password" element={<ChangePassword />} /> {/* เพิ่ม Route สำหรับ ChangePassword */}
        <Route path="/typeservices" element={<Typeservices />} /> {/* Add this line */}
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/MemberMLM" element={<MemberMLM />} />
        <Route path="/travel" element={<ContentTravel />} />
        <Route path="/packagematching" element={<PackageMatching />} />
        
        <Route path="/receipt-package-matching/:userId" element={<ReceiptPackageMatching />} />

        <Route
          path="/explore-internet"
          element={<ExploreInternet component={InternetView} />}
        />

        <Route
          path="/explore-internet-header"
          element={<ExploreInternet component={InternetHeaderView} />}
        />

        <Route path="/explore-ideas-lab" element={<ExploreIdeasLab />} />
        
        {/* --- ส่วนที่แก้ไข --- */}
        {/* Route เดิมสำหรับหน้าที่ 1 (ไม่มีเลขหน้า) */}
        <Route path="/explore-blog-ttt" element={<ExploreBlogTTT />} /> 
        {/* Route ใหม่สำหรับหน้าอื่นๆ โดยใช้ URL Parameter ชื่อ pageNumber */}
        <Route path="/explore-blog-ttt/currentPage/:pageNumber" element={<ExploreBlogTTT />} />
        {/* -------------------- */}
        
        <Route path="/explore-blog" element={<ExploreBlog />} />
        
        <Route path="/explore-tour" element={<ExploreTour />} />

        <Route path="/tour-package" element={<TourPackage />} />
        
        <Route path="/Logout" element={<Logout />} />
        <Route path="/report/*" element={<Reports />} />

      </Routes>
    </Router>
  );
};

export default App;
